import React,{useState} from 'react';
import Presenter from './KindQnaPresenter'
import { withRouter } from "react-router-dom";
import { SEEUSER } from '../../Queries/seeUser';
import { useQuery } from '@apollo/react-hooks';
import { SEE_CATEGORIES } from '../../Queries/seeCategories';
import { useHistory } from 'react-router-dom'

export default withRouter(({ match: { params: { channelId } } }) => {
    const history = useHistory();
    const {data, loading} = useQuery(SEEUSER,{
        variables:{
            channelId
        }
    })
    const { data: ctgData, loading: ctgLoading } = useQuery(SEE_CATEGORIES,{
        variables:{
            userChannelId:channelId
        }
    })
    const [createCategoryWindow, setCreateCategoryWindow] = useState(false)
    
    return(
        <Presenter 
            data={data}
            loading={loading}
            ctgData={ctgData}
            ctgLoading={ctgLoading}
            createCategoryWindow={createCategoryWindow}
            setCreateCategoryWindow={setCreateCategoryWindow}
            channelId={channelId}
            history={history}
        />
    )
        
})
